import React, { useState, useContext, useEffect } from 'react';

import { useCurrentUser } from 'Auth';
import { useLoadUsers } from 'Auth/data';
import trim from 'lodash/trim';

import {
  Stack,
  View,
  ListItemButton,
  ListItemText,
  List,
  Typography,
  Divider,
  SearchInput,
  makeStyles,
} from '@gogame/components';

import AuthContext from '../AuthContext';

const useStyles = makeStyles((theme) => {
  return {
    root: {},
    search: {
      padding: '16px',
    },
    list: {
      overflow: 'auto',
      paddingTop: 0,
      height: 'calc(100vh - 134px)',
      '&::-webkit-scrollbar-track': {
        borderLeft: `1px solid ${theme.palette.divider}`,
      },
    },
  };
});

const SearchField = ({ onChange }) => {
  const [value, setValue] = useState('');

  const handleChange = (_e, value) => {
    setValue(value);
    onChange(trim(value));
  };

  return (
    <SearchInput value={value} placeholder={'Search'} onChange={handleChange} />
  );
};

export const Impersonate = ({ onClose }) => {
  const [viewData, setViewData] = useState([]);
  const [searchFilter, setSearchFilter] = useState('');

  const classes = useStyles();
  const user = useCurrentUser();

  const { impersonate } = useContext(AuthContext);
  const { data = [], isLoading } = useLoadUsers();

  const handleApply = async (userId) => {
    await impersonate({ userId });
    onClose();
  };

  useEffect(() => {
    if (!data.length) {
      return;
    }

    const arrayForSearch = data.map((item) => {
      return {
        id: item.id,
        string: item.name,
      };
    });

    if (searchFilter && searchFilter.length > 0) {
      const filteredItemsIds = arrayForSearch
        .filter((item) => {
          return item.string.toLowerCase().includes(searchFilter.toLowerCase());
        })
        .map((item) => item.id);

      setViewData(
        data.filter((item) => {
          return filteredItemsIds.includes(item.id);
        })
      );
    } else {
      setViewData([...data]);
    }
  }, [data, searchFilter]);

  return (
    <View loading={isLoading}>
      <Stack direction={'column'} className={classes.root}>
        {!isLoading && (
          <>
            <div className={classes.search}>
              <SearchField onChange={setSearchFilter} />
            </div>
          </>
        )}
        <Stack direction={'column'}>
          <Divider />
          <List className={classes.list}>
            {viewData?.map(({ id, name }) => (
              <ListItemButton
                disabled={id === user.id}
                onClick={() => handleApply(id)}
              >
                <ListItemText primary={<Typography>{name}</Typography>} />
              </ListItemButton>
            ))}
          </List>
        </Stack>
      </Stack>
    </View>
  );
};
export default Impersonate;
